import React, { Component } from 'react'

class Messages extends Component {
  render() {
    return (
      <div className="col s12 m8 offset-m2 offset-13">
        <div className="card-panel grey lighten-5 z-depth-1">
          <div className="row valign-wrapper">
            {this.props.speaks === 'bot' && (
              <div className="col s2">
                <div className="btn-floating btn-large waves-effect waves-light red">
                  {this.props.speaks}
                </div>
              </div>
            )}
            <div className="col s10">
              <span className="black-text">
                {this.props.text}
              </span>
            </div>
            {this.props.speaks === 'me' && (
              <div className="col s2">
                <div className="btn-floating btn-large waves-effect waves-light red">
                  {this.props.speaks}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Messages
